"use strict";
import menuToggle from "./components/menu-toggle";
import projectSlider from "./modules/project-slider";
import delayLink from "./modules/delay-link";
import smoothScroll from "./components/smooth-scroll";
import equalHeight from "./components/equal-height";
import menuPosition from "./components/menu-position";
import projectsSizer from "./components/projects-sizer";

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.header__home-logo')) {
        menuToggle();
    }

    if (document.querySelector('.single-project__sliders-row')) {
        projectSlider();
    }

    if (document.querySelector('.projects__item-link')) {
        delayLink();
    }

    if (document.querySelector('.page-template-about')) {
        smoothScroll();
    }

    if (document.querySelector('.single-project__right-slider-slide')) {
        equalHeight();
    }

    if (document.querySelector('.header')) {
        menuPosition();
    }

    if (document.querySelector('.single-project__slider-block')) {
        projectsSizer();
    }

});

window.addEventListener('load', function() {
    document.body.style.opacity = '1';
});
